import { motion } from "framer-motion";
import { EASE } from "./Reveal";

export default function PageHeader({ eyebrow, title, accent, description, testid }) {
  return (
    <header data-testid={testid} className="grid-lines relative overflow-hidden pb-14 pt-32 md:pb-20 md:pt-44">
      <div className="pointer-events-none absolute -top-32 left-1/4 h-96 w-96 rounded-full bg-aurora/10 blur-[130px]" />
      <div className="pointer-events-none absolute -bottom-24 right-0 h-72 w-72 rounded-full bg-comet/10 blur-[120px]" />
      <div className="relative mx-auto max-w-7xl px-6">
        <motion.p
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, ease: EASE }}
          className="font-mono text-xs uppercase tracking-[0.3em] text-aurora"
        >
          {eyebrow}
        </motion.p>
        <div className="overflow-hidden">
          <motion.h1
            initial={{ y: "110%" }}
            animate={{ y: "0%" }}
            transition={{ duration: 0.9, delay: 0.08, ease: EASE }}
            className="mt-5 font-display text-4xl font-extrabold leading-[1.05] tracking-[-0.03em] text-slate-50 sm:text-5xl lg:text-6xl"
          >
            {title}{" "}
            {accent && (
              <em className="font-editorial font-medium italic text-comet">{accent}</em>
            )}
          </motion.h1>
        </div>
        {description && (
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.22, ease: EASE }}
            className="mt-6 max-w-2xl text-base leading-relaxed text-slate-400 md:text-lg"
          >
            {description}
          </motion.p>
        )}
      </div>
    </header>
  );
}
